<div class="history-backdrop" (click)="closed.emit()"></div>
<aside class="history-drawer" role="dialog" aria-modal="true" [attr.aria-label]="'history.dialog' | transloco">
  <div class="history-heading">
    <div class="eyebrow">{{ 'history.eyebrow' | transloco }}</div>
    <button type="button" mat-stroked-button (click)="closed.emit()">{{ 'actions.close' | transloco }}</button>
  </div>
  <h2>{{ row().key }}</h2>
  <div class="eyebrow">{{ 'history.lineage' | transloco }}</div>
  <div class="lineage" [attr.aria-label]="'history.lineageLabel' | transloco">
    @for (env of environments; track env.id; let last = $last) {
      <button type="button" class="lineage-card" [class.active]="historyEnvironment() === env.id" (click)="selectHistoryEnvironment(env.id)">
        <span class="lineage-title"><strong>{{ env.label }}</strong>@if (historyCount(env.id) > 0) { <span>v{{ historyCount(env.id) }}</span> }</span>
        @if (historyLatest(env.id); as latest) {
          @if (historyAuthor(latest); as author) {
            <span class="lineage-meta">
              @if (author.initials) { <span class="editor-avatar" [style.background]="author.color" aria-hidden="true">{{ author.initials }}</span> }
              <span>{{ author.name }} · {{ author.when }}</span>
            </span>
          }
        } @else {
          <span class="lineage-meta">{{ 'history.noChanges' | transloco }}</span>
        }
      </button>
      @if (!last) { <span class="lineage-arrow" aria-hidden="true"><mat-icon>arrow_forward</mat-icon></span> }
    }
  </div>
  <div class="view-switch" role="group" [attr.aria-label]="'view.content' | transloco">
    <button type="button" [class.active]="renderMode() === 'rendered'" [attr.aria-pressed]="renderMode() === 'rendered'" (click)="renderMode.set('rendered')">{{ 'view.rendered' | transloco }}</button>
    <button type="button" [class.active]="renderMode() === 'raw'" [attr.aria-pressed]="renderMode() === 'raw'" (click)="renderMode.set('raw')">{{ 'view.raw' | transloco }}</button>
  </div>
  <div class="history-tabs" role="tablist" [attr.aria-label]="'history.tabs' | transloco">
    @for (env of environments; track env.id) {
      <button type="button" role="tab" [attr.aria-selected]="historyEnvironment() === env.id" [class.active]="historyEnvironment() === env.id" (click)="selectHistoryEnvironment(env.id)">{{ env.label }} {{ historyCount(env.id) }}</button>
    }
  </div>
  @if (historyLoading()) { <div class="loading-state" role="status"><mat-spinner diameter="28"></mat-spinner><span>{{ 'status.loadingHistory' | transloco }}</span></div> }
  @if (historyError(); as historyMessage) { <p class="history-error" role="alert">{{ historyMessage | transloco }}</p> }
  @if (!historyLoading()) {
    <p class="history-hint">{{ 'history.hint' | transloco:{ env: label(historyEnvironment()) } }}</p>
    @if (historyEntries().length === 0) {
      <p class="history-hint">{{ 'history.empty' | transloco }}</p>
    } @else {
      <ul class="history-list">
        @for (entry of historyEntries(); track entry.id) {
          <li>
            <div class="history-entry">
            <button type="button" class="history-row" [attr.aria-expanded]="isHistoryExpanded(entry.id)" (click)="toggleHistory(entry.id)">
              <mat-icon class="history-chevron" [class.open]="isHistoryExpanded(entry.id)" aria-hidden="true">expand_more</mat-icon>
              @if (historyAuthor(entry); as author) {
                @if (author.initials) { <span class="editor-avatar" [style.background]="author.color" aria-hidden="true">{{ author.initials }}</span> }
                <span class="history-copy">
                  <span class="history-title"><strong>v{{ historyVersion(entry) }}</strong><span class="history-id">{{ historyShortId(entry.id) }}</span><span class="history-change">{{ historyChangeLabel(entry) }}</span></span>
                  <span class="history-meta">{{ author.name }} · {{ author.when }}@if (author.ago) { · {{ author.ago }}}</span>
                </span>
              }
            </button>
            <button type="button" class="history-checkout" mat-stroked-button (click)="checkoutEntry(entry, $event)">{{ 'history.checkout' | transloco }}</button>
            </div>
            @if (isHistoryExpanded(entry.id)) {
              @for (kind of historyKinds(entry); track kind) {
                <div class="content-grid history-diff">
                  <section><h3>{{ 'history.before' | transloco }} · {{ historyKindLabel(kind) }}</h3><app-diff-view [lines]="historyLines(entry, kind, 'left')" tone="removed" /></section>
                  <section><h3>{{ 'history.after' | transloco }} · {{ historyKindLabel(kind) }}</h3><app-diff-view [lines]="historyLines(entry, kind, 'right')" tone="added" /></section>
                </div>
              }
            }
          </li>
        }
      </ul>
    }
  }
</aside>
